import { render, staticRenderFns } from "./NewDetail.vue?vue&type=template&id=470f3165&scoped=true&"
import script from "./NewDetail.vue?vue&type=script&lang=ts&"
export * from "./NewDetail.vue?vue&type=script&lang=ts&"
import style0 from "./NewDetail.vue?vue&type=style&index=0&id=470f3165&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f3165",
  null
  
)

export default component.exports